import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-add-press',
  templateUrl: './add-press.component.html',
  styleUrls: ['./add-press.component.css']
})
export class AddPressComponent implements OnInit {


  constructor(@Inject(MAT_DIALOG_DATA) public passedData:any) { }

  ngOnInit() {
  }

}
